import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'users-and-roles.actors-table.table-empty-view.header',
		defaultMessage: "Where's everybody?",
		description: 'Header text for empty users table.',
	},
	noOneInProject: {
		id: 'users-and-roles.actors-table.table-empty-view.no-one-in-project',
		defaultMessage: 'There is no one in this project.',
		description: 'Text suggesting no user/ group in the project.',
	},
	addYourselfToTeam: {
		id: 'users-and-roles.actors-table.table-empty-view.add-yourself-to-team',
		defaultMessage: "Don't worry. Add yourself or your team, and we'll tell them to join.",
		description: 'Text suggesting user to add themselves to the team.',
	},
});
